export const buttonGroups = {
  gridColumnGap: "1rem",
  gridRowGap: "1rem",
  flexWrap: "wrap",
  alignItems: "center",
  display: "inline-flex",
};
